module.exports = __webpack_public_path__ + "static/img/zlr.e15a0265.png";